import isNil from 'lodash-es/isNil'

import { APPOINTMENT_MOCK_REQUEST_NUMBER_PREFIX } from '../Appointment.constants'

import { APPOINTMENT_FORM_FIELD_NAME } from './AppointmentFormModal.constants'
import { getAppointmentFormMockParticipants } from './AppointmentFormModal.utils.participants'

function toAppointmentFormMockAnchor(item) {
  return item ? { id: item.value, name: item.label } : null
}

function getAppointmentFormMockRequestNumber(request) {
  return isNil(request.number)
    ? null
    : `${APPOINTMENT_MOCK_REQUEST_NUMBER_PREFIX}${request.number}`
}

function toAppointmentFormMockRequest({ building, flat, request }) {
  return request
    ? {
        building,
        can_edit_due_date: request.canEditDueDate,
        due_date: request.dueDate,
        flat,
        number: getAppointmentFormMockRequestNumber(request),
        title: request.title,
      }
    : null
}

export function getAppointmentFormMockContext({
  restoreJobEnabled,
  timezone,
  userData,
  values,
}) {
  const building = toAppointmentFormMockAnchor(
    values[APPOINTMENT_FORM_FIELD_NAME.building]
  )
  const flat = toAppointmentFormMockAnchor(
    values[APPOINTMENT_FORM_FIELD_NAME.flat]
  )
  const request = values[APPOINTMENT_FORM_FIELD_NAME.request]

  return {
    anchors: {
      building,
      emailThread: values[APPOINTMENT_FORM_FIELD_NAME.emailThread],
      flat,
      request: toAppointmentFormMockRequest({ building, flat, request }),
      resident: values[APPOINTMENT_FORM_FIELD_NAME.resident],
    },
    participants: getAppointmentFormMockParticipants({
      participants: values[APPOINTMENT_FORM_FIELD_NAME.participants],
      userData,
    }),
    restoreJobEnabled,
    timezone,
    user: userData && { id: userData.id, name: userData.fullname },
  }
}
